import { Box, Grid, Theme, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { investmentPreferenceMasterData } from '../../redux-store/actions';
import {
  ApplicationProps,
  investmentpreferencesType,
  InvestmentPreferenceMasterType,
  assetallocationguidelinesType,
  TypeInvestmentPreferenceMdms,
  allocationlimitsType,
  tolerancelimitsType,
} from '../../redux-store/types/api-types';
import { currencyConversion } from '../../utils/utilityFunctions';
import { DataTable, WebViewDataRow } from '../DataTable';
import { SubHeading } from '../investors/components';
import { updatedServicePreference } from '../investors/servicePreferenceDetails';
import { Gridstyles, Item, ItemDetails } from './index';
import { KeyValue } from './personalDetails';
import { RootStateType } from '../../redux-store/reducers';
import { currencyCodeMap } from '../../utils/constant';

export default function InvestmentPreference({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const theme = useTheme();
  const {
    investmentpreferences = [],
    tolerancelimits = [],
    allocationlimits = [],
    assetallocationguidelines = [],
  } = application || {};
  const [investmentPreferenceData, setInvestmentPreferenceData] = useState<any>([]);
  const dispatch = useDispatch();

  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

  const assetAllocationHeaders = [
    {
      header: 'Asset Class*',
      label: 'assetClass',
      valueGetter: (row: assetallocationguidelinesType) => row.assetClass || 'N/A',
    },
    {
      header: 'Minimum Allocation %',
      label: 'minimumAllocation',
      valueGetter: (row: assetallocationguidelinesType) => row.minimumAllocation + ' %' || 'N/A',
      outerCellStyles: {
        paddingLeft: "10px",
        paddingRight: "10px"
      },
      innerCellStyles: {
        border: `1px solid  ${theme.palette.primary[500]}`,
        borderRadius: "10px"
      }
    },
    {
      header: 'Maximum Allocation %',
      label: 'maximumAllocation',
      valueGetter: (row: assetallocationguidelinesType) => row.maximumAllocation + ' %' || 'N/A',
      outerCellStyles: {
        paddingLeft: "10px",
        paddingRight: "10px"
      },
      innerCellStyles: {
        border: `1px solid  ${theme.palette.primary[500]}`,
        borderRadius: "10px"

      }
    },
  ];

  const allocationlimitHeaders = [
    {
      header: 'Maturity Buckets',
      label: 'maturityBuckets',
      valueGetter: (row: allocationlimitsType) => row.maturityBuckets || 'N/A',
      outerCellStyles: {
        width: '61%'

      },

    },
    {
      header: 'Indicative Allocation',
      label: 'indicativeAllocation',
      valueGetter: (row: allocationlimitsType) => row.indicativeAllocation + ' %' || 'N/A',
      outerCellStyles: {
        paddingLeft: "10px",
        paddingRight: "10px",


      },
      innerCellStyles: {
        border: `1px solid  ${theme.palette.primary[500]}`,
        borderRadius: "10px"
      }
    },
  ];
  const tolerancelimitsHeaders = [
    {
      header: 'Fixed Income Category*',
      label: 'fixedIncomeCategory',
      valueGetter: (row: tolerancelimitsType) => row.fixedIncomeCategory || 'N/A',
    },
    {
      header: 'Allocation %',
      label: 'allocation',
      valueGetter: (row: tolerancelimitsType) => row.allocation + ' %' || 'N/A',
      outerCellStyles: {
        paddingLeft: "10px",
        paddingRight: "10px",

      },
      innerCellStyles: {
        border: `1px solid  ${theme.palette.primary[500]}`,
        borderRadius: "10px"
      }
    },
  ];
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(
          investmentPreferenceMasterData()
        )) as unknown as TypeInvestmentPreferenceMdms;
        setInvestmentPreferenceData({
          ...investmentPreferenceData,
          investmentpreferences: response.invesmentQuestions
            .map((preference) => {
              let ans = [] as any;
              preference.questions.map((a) => {
                const existingInvestmentPreference = investmentpreferences?.filter(
                  (data) => data.question === a.questionKey
                );
                ans = existingInvestmentPreference.length
                  ? existingInvestmentPreference.map((preferences) => {
                    if (preferences.question === a.questionKey) {
                      return {
                        ...preferences,
                        ...a,
                        question: a.questionKey,
                        answer: preferences.answer,
                        section: preference.SectionHeading,
                      };
                    }
                  })
                  : [
                    {
                      ...investmentpreferences,
                      question: a.questionKey,
                      answer: '',
                      section: preference.SectionHeading,
                      ...a,
                    },
                  ];
              });
              return ans;
            })
            .flat(),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: theme.palette.customColors.infoCard,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}>
        <Box >
          <Grid container>
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
              Investment Preference
            </Typography>
            {investmentPreferenceData?.investmentpreferences?.map((preferenceData: any) => {
              const ans = preferenceData?.options?.find(
                (option: any) => option.key === preferenceData.answer
              );
              return (
                <React.Fragment key={preferenceData?.id}>
                  <SubHeading sx={{ letterSpacing: "0.02px" }}>
                    {preferenceData.section}
                  </SubHeading>
                  {/* <Gridstyles> */}
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    {/* {preferenceData.questions?.map((question: any) => {
                        return (
                          <React.Fragment key={question.questionKey}> */}
                    {preferenceData.questionText &&
                      preferenceData.question !== 'liquidateAssetsunder' && (
                        <KeyValue title={preferenceData.questionText} description={ans?.label} />
                      )}

                    {preferenceData.question === 'liquidateAssetsunder' &&
                      preferenceData.questionText && (
                        <Grid item xs={12} sm={12}>
                          <Item>{preferenceData.questionText}</Item>
                          <ItemDetails>
                            {' '}
                            {ans?.label
                              ? ans?.key === 'yes'
                                ? 'Yes' + ` (anticipated amount in ${currencyCodeMap[currencyCode?.toLowerCase()]})`
                                : ans?.label
                              : '-'}
                          </ItemDetails>
                          {preferenceData.value && <Item>{preferenceData.value}</Item>}
                          {preferenceData.value && Number(preferenceData.value) > 0 && (
                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: 14,
                                // mb: -4,
                                mt: 1,
                              }}>
                              {currencyConversion(locale, Number(preferenceData.value))}
                            </Typography>
                          )}
                        </Grid>
                      )}
                    {!preferenceData.questionText && (
                      <Grid item xs={12} sm={6}>
                        <ItemDetails>
                          {' '}
                          {preferenceData.answer || preferenceData.value || '-'}
                        </ItemDetails>
                        {preferenceData.answer && Number(preferenceData.answer) > 0 && (
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: 14,
                              // mb: -4,
                              mt: 1,
                            }}>
                            {currencyConversion(locale, Number(preferenceData.answer))}
                          </Typography>
                        )}
                      </Grid>
                    )}
                    {/* </React.Fragment>
                        );
                      })} */}
                  </Grid>
                  {/* </Gridstyles> */}
                </React.Fragment>
              );
            })}

            <SubHeading sx={{ letterSpacing: "0.02px" }}>Asset Allocation guidelines</SubHeading>

            {/* <Gridstyles> */}
            <Box sx={(theme: Theme) => ({ width: '100%', mt: '9px', })}>
              <Typography variant='body_500' sx={{ color: 'text.primary', mb: 2 }}>
                {`Please indicate the broad asset allocation guidelines to be implemented for the investment advice.`}
              </Typography>
              <Box sx={(theme: Theme) => ({ border: `1px solid ${theme.palette.grey[100]}`, padding: '25px', borderRadius: '10px' })}>

                <DataTable
                  tableData={assetallocationguidelines}
                  tableHeader={assetAllocationHeaders}
                  renderAdditionalRow={false}
                  tableHeaderCustomStyles={{

                    '.MuiTableCell-head': {
                      fontFamily: theme.typography.fontFamily,
                      fontSize: 16,
                      fontWeight: 500,
                      color: theme.palette.primary[900],
                      textAlign: 'left',

                      // px: 2,
                      // py: 1.5,
                      // width: '30%',
                      // bgcolor: '#F3F8FB',
                    },
                  }}
                  rowCustomStyles={{
                    '.MuiTableCell-root': {
                      fontFamily: theme.typography.fontFamily,
                      fontSize: 16,
                      fontWeight: 500,
                      color: theme.palette.text.primary,
                      px: 2,
                      py: 1.5,

                      // width: '30%',
                      overflowWrap: 'anywhere',
                      textAlign: 'left',
                      verticalAlign: 'top',
                    },
                    // '&:nth-child(odd)': {
                    //   bgcolor: 'rgba(19, 24, 54, 0.02)',
                    // },
                  }}
                  boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                />
              </Box>
            </Box>
            {/* </Gridstyles> */}
            {/* <Gridstyles> */}
            <Box sx={{ mt: 4, width: '100%' }}>
              <Typography variant='body_500' sx={{ color: 'text.primary', mb: 2 }}>
                {`Allocation limit for the below Fixed income maturities.`}
              </Typography>
              <Box sx={(theme: Theme) => ({ border: `1px solid ${theme.palette.grey[100]}`, padding: '25px', borderRadius: '10px' })}>
                <Box sx={{ width: '70%' }}>

                  <DataTable
                    tableData={allocationlimits}
                    tableHeader={allocationlimitHeaders}
                    renderAdditionalRow={false}
                    tableHeaderCustomStyles={{
                      '.MuiTableCell-head': {
                        fontFamily: theme.typography.fontFamily,
                        fontSize: 16,
                        fontWeight: 500,
                        color: theme.palette.primary[900],
                        textAlign: 'left',
                        // px: 1,
                        py: 1.5,
                        // width: '30%',
                        // bgcolor: '#F3F8FB',
                      },
                    }}
                    rowCustomStyles={{
                      '.MuiTableCell-root': {
                        fontFamily: theme.typography.fontFamily,
                        fontSize: 16,
                        fontWeight: 500,
                        color: theme.palette.text.primary,
                        px: 2,
                        py: 1.5,
                        // width: '30%',
                        overflowWrap: 'anywhere',
                        textAlign: 'left',
                        verticalAlign: 'top',
                      },
                      // '&:nth-child(odd)': {
                      //   bgcolor: 'rgba(19, 24, 54, 0.02)',
                      // },
                    }}
                    boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                  />
                </Box>
              </Box>
            </Box>
            {/* </Gridstyles> */}
            {/* <Gridstyles> */}
            <Box sx={{ mt: 4, width: '100%' }}>
              <Typography variant='body_500' sx={{ color: 'text.primary', mb: 2 }}>
                {`Tolerance limits for the below Fixed income category.`}
              </Typography>

              <Box sx={(theme: Theme) => ({ border: `1px solid ${theme.palette.grey[100]}`, padding: '25px', borderRadius: '10px' })}>
                <Box sx={{ width: '70%' }}>
                  <DataTable
                    tableData={tolerancelimits}
                    tableHeader={tolerancelimitsHeaders}
                    renderAdditionalRow={false}
                    tableHeaderCustomStyles={{
                      '.MuiTableCell-head': {
                        fontFamily: theme.typography.fontFamily,
                        fontSize: 16,
                        fontWeight: 500,
                        color: theme.palette.primary[900],
                        textAlign: 'left',
                        px: 2,
                        py: 1.5,
                        // width: '30%',
                        // bgcolor: '#F3F8FB',
                      },
                    }}
                    rowCustomStyles={{
                      '.MuiTableCell-root': {
                        fontFamily: theme.typography.fontFamily,
                        fontSize: 16,
                        fontWeight: 500,
                        color: theme.typography.fontFamily,
                        px: 2,
                        py: 1.5,
                        // width: '30%',
                        overflowWrap: 'anywhere',
                        textAlign: 'left',
                        verticalAlign: 'top',
                      },
                      // '&:nth-child(odd)': {
                      //   bgcolor: 'rgba(19, 24, 54, 0.02)',
                      // },
                    }}
                    boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                  />
                </Box>
              </Box>
            </Box>
            {/* </Gridstyles> */}

            {/* <Grid container pt={3}>
              <Grid item xs={12} alignSelf="center"> */}

            {/* <WebViewDataRow
                  tableData={assetallocationguidelines}
                  tableHeader={assetAllocationHeaders}
                  renderAdditionalRow={false}
                  tableHeaderCustomStyles={{
                    '.MuiTableCell-head': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'primary.main',
                    },
                  }}
                  rowCustomStyles={{
                    '.MuiTableCell-root': {
                      py: '8px',
                      overflowWrap: 'anywhere',
                      padding: { xs: '10px', sm: '30px' },
                    },
                  }}
                  tableBodyCustomStyles={{
                    '.MuiTableRow-root': {
                      '&:last-child': {
                        borderBottom: 'none',
                      },
                    },
                  }}
                /> */}
            {/* </Grid>
            </Grid> */}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
